// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { cartActionsStyles } from "@turnerBlueprint/Overrides/Widgets/Cart/CartActions";
import IconPrint from "@turnerBlueprint/XDL/Icons/IconPrint";
import IconSave from "@turnerBlueprint/XDL/Icons/IconSave";
import IconTrash from "@turnerBlueprint/XDL/Icons/IconTrash";
import IconWishlist from "@turnerBlueprint/XDL/Icons/IconWishlist";
import { color, iconButtonCommonStyles, mergeWithCss, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

cartActionsStyles.wrapper = {
    css: css`
        display: flex;
        gap: 16px 24px;
        align-items: center;
        ${xScreen("lte", "md")} {
            flex-wrap: wrap;
        }
    `,
};

cartActionsStyles.printClickable = {
    ...iconButtonCommonStyles(IconPrint, 12),
};

cartActionsStyles.saveOrderClickable = {
    ...iconButtonCommonStyles(IconSave),
};

cartActionsStyles.addAllToListClickable = {
    ...iconButtonCommonStyles(IconWishlist, 9, {}, "transparent", {
        css: css`
            &:hover {
                &&& ${IconWrapper}, &&& svg {
                    color: ${color("text.link")};
                    opacity: 1;
                }
            }
        `,
    }),
};

cartActionsStyles.removeAllClickable = {
    ...mergeWithCss(iconButtonCommonStyles(IconTrash), {
        css: css`
            margin-left: auto;
            svg {
                overflow: unset;
            }
        `,
    }),
};

cartActionsStyles.condensedViewCheckboxGroup = {
    css: css`
        ${xScreen("lte", "md")} {
            flex-basis: 50%;
        }
    `,
};
